import showcases from "../../../data/showcases.json";
import styles from "./WebsiteIdeas.module.css";

const ideas = [
  { slug: "restaurant-websites", line: <>A taste of what<br />makes you different.</>, category: "FOOD & HOSPITALITY" },
  { slug: "retail-websites", line: <>Your next customer.<br />Your new front door.</>, category: "RETAIL & LIFESTYLE" },
];

export default function WebsiteIdeas() {
  return (
    <section className={styles.section} aria-labelledby="website-ideas-title">
      <div className="container">
        <header className={styles.header} data-reveal="">
          <div><span className="eyebrow">Imagine your business here</span><h2 id="website-ideas-title">Different businesses.<br />Same big ambition.</h2></div>
          <div><p>A website should feel like you. Explore the possibilities for your kind of business.</p><a href="/websites">Find your inspiration <span aria-hidden="true">↗</span></a></div>
        </header>
        <div className={styles.grid}>
          {ideas.map((idea, index) => {
            const item = showcases.find(entry => entry.slug === idea.slug);
            return <a href={item.path} className={styles.idea} key={idea.slug} data-reveal="">
              <div className={styles.visual}>
                <img src={item.image.src} srcSet={`${item.image.small} 600w, ${item.image.src} 1200w`} sizes="(max-width: 700px) 100vw, 50vw" alt={item.image.alt} loading="lazy" width="1200" height="900" />
                <span className={styles.category}>{idea.category}</span>
                <div className={styles.visualCopy}><span>MADE TO BE DISCOVERED</span><strong>{idea.line}</strong></div>
                <span className={styles.explore} aria-hidden="true">↗</span>
              </div>
              <div className={styles.caption}><div><span>0{index + 1} / WEBSITE POSSIBILITIES</span><h3>{item.title}</h3></div><span aria-hidden="true">↗</span></div>
            </a>;
          })}
        </div>
      </div>
    </section>
  );
}
